import { ActivityIndicator, ScrollView, View } from 'react-native'
import { useState } from 'react'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'

const NyInformationOnline = ({ navigation, route }: any) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const { postnyonline, loading } = useFormsStore()

    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey:
                intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey:
                essUserOnBoardingFormKey,
            completeOnline: true,
            sign: signatureDataURL,
            isNyResident: values?.is_nyc_resident == 1 ? 1 : 0,
            isYkResident: values?.is_yonkers_resident == 1 ? 1 : 0,
            maritalStatus: values?.martialstatus,
            totalAllowancesForNy: values?.toalAllowancesforNewyork ? values?.toalAllowancesforNewyork : null,
            totalForNyandYonkers: values?.totalfornyandyonkers,
            nyStateAmount: values?.nystateamount ? values?.nystateamount : null,
            nyCityAmount: values?.nycityamount ? values?.nycityamount : null,
            ykAmount: values?.yonkersamount ? values?.yonkersamount : null
        }
        const response = await postnyonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }


    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'NY Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('NyInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",

                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}

export default NyInformationOnline
